import { Box } from '@chakra-ui/react'
import { faStar as faStarOutline } from '@fortawesome/pro-regular-svg-icons'
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'

import Tippy from '@/components/UI/Tippy'

export default function StarWithTooltip({
  tooltipContent,
  onClick,
  color,
  solid = false,
  fontSize,
  disabled,
}: {
  tooltipContent: string | React.ReactElement
  onClick?: () => Promise<void>
  color?: string
  solid?: boolean
  fontSize?: number
  disabled?: boolean
}): ReactElement {
  return (
    <Tippy
      disabled={disabled}
      content={<div style={{ textAlign: 'center', display: 'flex' }}>{tooltipContent}</div>}
    >
      <Box
        cursor={onClick != null ? 'pointer' : undefined}
        role={onClick != null ? 'button' : undefined}
        color={color}
        onClick={onClick}
        fontSize={fontSize}
        width="fit-content"
        rounded={100}
        p={2}
        _hover={{
          background: 'bg.muted',
        }}
      >
        <FontAwesomeIcon icon={solid ? faStarSolid : faStarOutline} />
      </Box>
    </Tippy>
  )
}
